import { useEffect } from 'react'
import { AppConfig, AppConfigActions } from '@AppState/app-config'
import { useAppDispatch } from '@AppState/redux-store'

export const AppConfigLoader = () => {
  const dispatch = useAppDispatch()
  useEffect(() => {
    console.log(`💠 Loading App Config`)

    const appConfig: AppConfig = {
      backOfficeDataServiceUrl: import.meta.env.VITE_BACK_OFFICE_DATA_SERVICE_URL,
    }

    dispatch(AppConfigActions.setAppConfig(appConfig))
  }, [dispatch])

  return <></>
}
